export const selectSantanderDomiciledCollection = state => 
  state.santanderDomiciledCollection || { 
    items: [], 
    count: 0, 
    options: { 
      limit: +process.env.REACT_APP_TABLE_SIZE || 10, 
      page: 0,
      startDate: null,
      endDate: null
    } 
  };
export const selectSantanderDomiciledCollectionList = state =>
  selectSantanderDomiciledCollection(state).items || [];
export const selectSantanderDomiciledCollectionCount = state =>
  selectSantanderDomiciledCollection(state).count || 0;
export const selectSantanderDomiciledCollectionQueryOptions = state => {
  const { options } = selectSantanderDomiciledCollection(state);

  Object.keys(options).forEach(key => {
    if (options[key] === '') {
      delete options[key];
    }
  });

  return options || { limit: +process.env.REACT_APP_TABLE_SIZE || 10, page: 0 };
};

